module.exports = __webpack_public_path__ + "img/refund_desktop.67dea5c2.svg";